// @flow
import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {DeleteState} from 'redux/v1/insurance/delete/DeleteState';
import type {GetState} from 'redux/v1/insurance/get/GetState';
import type {PutState} from 'redux/v1/insurance/put/PutState';

import {insuranceState} from 'redux/v1/V1State';

export type InsuranceState = {
  get: GetState,
  put: PutState,
  delete: DeleteState,
};

export const getState = (state: ApplicationRedux): GetState =>
  insuranceState(state).get;

export const putState = (state: ApplicationRedux): PutState =>
  insuranceState(state).put;

export const deleteState = (state: ApplicationRedux): DeleteState =>
  insuranceState(state).delete;
